// import "./QuoteSection.css";
// import {
//   FaUser,
//   FaEnvelope,
//   FaPhoneAlt,
//   FaTag,
//   FaCommentDots,
//   FaHeadset
// } from "react-icons/fa";

// export default function QuoteSection() {
//   return (
//     <section id="contact" className="quote-section">

//       <div className="container">

//         <div className="quote-wrapper">

//           {/* LEFT SIDE */}

//           <div className="quote-content">

//             <span className="quote-tag">
//               LET'S TALK
//             </span>

//             <h2>
//               <span>Grow your business</span> with our
//               intelligent digital solutions.
//             </h2>

//             <p>
//               We help startups, enterprises, and growing businesses
//               accelerate digital transformation through AI-powered
//               applications, enterprise software, cloud platforms,
//               IoT solutions, and innovative technology products.
//             </p>

//             <div className="expert-card">

//               <div className="expert-icon">
//                 <FaHeadset />
//               </div>

//               <div className="expert-info">

//                 <h4>+91 86884 77777</h4>

//                 <span>
//                   TALK TO AN EXPERT
//                 </span>

//               </div>

//             </div>

//           </div>

//           {/* RIGHT SIDE */}

//           <div className="quote-form">

//             <form>

//               <div className="row g-4">

//                 <div className="col-md-6">

//                   <label>
//                     <FaUser />
//                     Name
//                   </label>

//                   <input
//                     type="text"
//                     placeholder="Enter your name"
//                   />

//                 </div>

//                 <div className="col-md-6">

//                   <label>
//                     <FaPhoneAlt />
//                     Mobile Number
//                   </label>

//                   <input
//                     type="tel"
//                     placeholder="Enter mobile number"
//                   />

//                 </div>

//                 <div className="col-12">

//                   <label>
//                     <FaEnvelope />
//                     Email Address
//                   </label>

//                   <input
//                     type="email"
//                     placeholder="Enter your email"
//                   />

//                 </div>

//                 <div className="col-12">

//                   <label>
//                     <FaTag />
//                     Subject
//                   </label>

//                   <input
//                     type="text"
//                     placeholder="Enter subject"
//                   />

//                 </div>

//                 <div className="col-12">

//                   <label>
//                     <FaCommentDots />
//                     Message
//                   </label>

//                   <textarea
//                     rows="6"
//                     placeholder="Tell us about your project..."
//                   ></textarea>

//                 </div>

//               </div>

//               <button type="submit">
//                 SEND MESSAGE
//               </button>

//             </form>

//           </div>

//         </div>

//       </div>

//     </section>
//   );
// }


import { useState } from "react";
import "./QuoteSection.css";
import {
  FaUser,
  FaEnvelope,
  FaPhoneAlt,
  FaTag,
  FaCommentDots,
  FaHeadset,
  FaMailchimp
} from "react-icons/fa";

export default function QuoteSection() {
  const [form, setForm] = useState({
    name: "",
    mobile: "",
    email: "",
    subject: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !form.name ||
      !form.mobile ||
      !form.email ||
      !form.subject ||
      !form.message
    ) {
      alert("Please fill all fields.");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(
        "https://g-g.co.in/api/contact.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(form),
        }
      );

      const result = await response.json();

      if (result.success) {
        alert(result.message);

        setForm({
          name: "",
          mobile: "",
          email: "",
          subject: "",
          message: "",
        });
      } else {
        alert(result.message);
      }
    } catch (error) {
      console.error(error);
      alert("Something went wrong.");
    }

    setLoading(false);
  };

  return (
    <section id="contact" className="quote-section">
      <div className="container">
        <div className="quote-wrapper">

          <div className="quote-content">
            <span className="quote-tag">LET'S TALK</span>

            <h2>
              Grow your business with our intelligent <span style={{'color' : '#08469a'}}>digital solutions.</span>
            </h2>

            <p>
              We help startups, enterprises, and growing businesses accelerate
              digital transformation through AI-powered applications,
              enterprise software, cloud platforms, IoT solutions, and
              innovative technology products.
            </p>

            <div className="expert-card">
              <div className="expert-icon" style={{'background' : '#f36b08'}}>
                <FaEnvelope />
              </div>

              <div className="expert-info">
                <h4>sales@g-g.co.in</h4>
                {/* <span>TALK TO AN EXPERT</span> */}
              </div>
            </div>
          </div>

          <div className="quote-form">
            <form onSubmit={handleSubmit}>
              <div className="row g-4">

                <div className="col-md-6">
                  <label>
                    <FaUser /> Name
                  </label>

                  <input
                    type="text"
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    placeholder="Enter your name"
                  />
                </div>

                <div className="col-md-6">
                  <label>
                    <FaPhoneAlt /> Mobile Number
                  </label>

                  <input
                    type="tel"
                    name="mobile"
                    value={form.mobile}
                    onChange={handleChange}
                    placeholder="Enter mobile number"
                  />
                </div>

                <div className="col-12">
                  <label>
                    <FaEnvelope /> Email Address
                  </label>

                  <input
                    type="email"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    placeholder="Enter your email"
                  />
                </div>

                <div className="col-12">
                  <label>
                    <FaTag /> Subject
                  </label>

                  <input
                    type="text"
                    name="subject"
                    value={form.subject}
                    onChange={handleChange}
                    placeholder="Enter subject"
                  />
                </div>

                <div className="col-12">
                  <label>
                    <FaCommentDots /> Message
                  </label>

                  <textarea
                    rows="6"
                    name="message"
                    value={form.message}
                    onChange={handleChange}
                    placeholder="Tell us about your project..."
                  />
                </div>
              </div>

              <button type="submit" disabled={loading}>
                {loading ? "SENDING..." : "SEND MESSAGE"}
              </button>
            </form>
          </div>

        </div>
      </div>
    </section>
  );
}